import { makeVar } from '@apollo/client';

export const trainingStudentView = makeVar(true);
